(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  let pending = false, again = false, timer;
  async function syncCart() {
    if (pending) { again = true; return; }
    pending = true;
    try {
      // Shopify renders the localized count and empty-cart icon together.
      const response = await fetch(root + '?section_id=cart-icon-bubble', {cache:'no-store', credentials:'same-origin'});
      if (!response.ok) return;
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const section = parsed.querySelector('#shopify-section-cart-icon-bubble');
      const target = document.getElementById('cart-icon-bubble');
      if (section && target && section.innerHTML.trim()) target.innerHTML = section.innerHTML;
    } catch (_) { /* Keep the last known count when offline. */ }
    finally { pending = false; if (again) { again = false; schedule(); } }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(syncCart, 150); }
  window.addEventListener('pageshow', syncCart);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  window.addEventListener('focus', schedule);
  window.addEventListener('storage', e => { if (e.key === 'lume-cart-changed') schedule(); });
  function changed() {
    schedule();
    try { localStorage.setItem('lume-cart-changed', String(Date.now())); } catch (_) {}
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, changed);
  // Observe completed Shopify mutations from both Dawn and third-party drawers.
  if (typeof PerformanceObserver !== 'undefined') {
    const observer = new PerformanceObserver(list => {
      for (const entry of list.getEntries()) {
        const url = new URL(entry.name, location.href);
        if (url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)) changed();
      }
    });
    observer.observe({type:'resource', buffered:false});
  }
  syncCart();
})();
